(() => {
  const initialized = new WeakSet();

  function initialize(section) {
    if (!section || initialized.has(section)) return;
    initialized.add(section);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    const speed = Math.max(20, Number(section.style.getPropertyValue('--rails-speed')) || 45);

    section.querySelectorAll('[data-rail-viewport]').forEach((viewport) => {
      const sequence = viewport.querySelector('[data-rail-sequence]');
      if (!sequence) return;
      const rail = viewport.closest('.grada-rail');
      const track = sequence.closest('.grada-rail__track');
      let stopped = false;
      let previousTime = 0;
      let visualClone = null;

      const removeVisualClone = () => {
        visualClone?.remove();
        visualClone = null;
      };

      const addVisualClone = () => {
        if (visualClone || mobileViewport.matches || reduceMotion || !track) return;
        visualClone = sequence.cloneNode(true);
        visualClone.removeAttribute('data-rail-sequence');
        visualClone.setAttribute('aria-hidden', 'true');
        visualClone.setAttribute('inert', '');
        visualClone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        track.appendChild(visualClone);
      };

      const syncVisualClone = () => {
        if (mobileViewport.matches || reduceMotion) removeVisualClone();
        else addVisualClone();
      };

      syncVisualClone();
      mobileViewport.addEventListener('change', syncVisualClone);

      const stop = () => { stopped = true; };
      ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((eventName) => {
        viewport.addEventListener(eventName, stop, { passive: eventName !== 'keydown' });
      });

      rail?.querySelectorAll('[data-rail-control]').forEach((button) => {
        button.addEventListener('click', () => {
          stop();
          const direction = button.dataset.railControl === 'previous' ? -1 : 1;
          viewport.scrollBy({ left: direction * Math.max(280, viewport.clientWidth * 0.72), behavior: 'smooth' });
        });
      });

      if (reduceMotion) return;

      const move = (time) => {
        if (!stopped && !document.hidden && !mobileViewport.matches) {
          if (previousTime) viewport.scrollLeft += Math.min(2.5, ((time - previousTime) / 1000) * speed);
          const resetPoint = sequence.offsetWidth + 14;
          if (resetPoint > 0 && viewport.scrollLeft >= resetPoint) viewport.scrollLeft -= resetPoint;
        }
        previousTime = time;
        requestAnimationFrame(move);
      };
      requestAnimationFrame(move);
    });
  }

  document.querySelectorAll('[data-grada-product-rails]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-grada-product-rails]')));
})();
